export const GET_STORE = 'GET_STORE'
export const SET_STORE = 'SET_STORE'
export const STORE = 'store'
export const CHECKOUT_INFOS = 'checkoutInfos'
export const STORE_MODULE = 'store'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const CHANGE_PAYMENT_METHOD_BANKSLIP = 'CHANGE_PAYMENT_METHOD_BANKSLIP'